import { IconName } from '@ardoq/icons';
import { AppliedSettingsRow } from './AppliedSettingsRow';
import { FilterSetting } from './types';
import { Tag } from '@ardoq/status-ui';
import { t, type I18nLocale } from '@ardoq/i18n';

type Props = {
  settings: FilterSetting;
  i18nLocale: I18nLocale;
};

export const FiltersSettings = ({ settings, i18nLocale }: Props) => {
  const { onEditClick, appliedFiltersCount } = settings;

  const tag = (
    <Tag label={appliedFiltersCount.toString()} key="Filters count" />
  );

  return (
    <AppliedSettingsRow
      label={t(i18nLocale, 'appLayout:filtersLabel', 'Filters')}
      icon={IconName.FILTER_LIST}
      tags={[tag]}
      onEditClick={onEditClick}
      isDisabled={!appliedFiltersCount}
      i18nLocale={i18nLocale}
    />
  );
};
